import axios from "axios";

const landingApi = axios.create({
  baseURL: process.env.REACT_APP_LANDING_BACKEND_URL,
});

landingApi.interceptors.request.use((config) => {
  const token = process.env.REACT_APP_LANDING_ACCESS_TOKEN;
  // window.localStorage.getItem("landing-accessToken") ||
  //   (config.url !== "/auth/local" ? "-" : "");
  if (token) config.headers.Authorization = "Bearer " + token;

  return config;
});

landingApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.config.url !== "/auth/local"
    ) {
      window.dispatchEvent(new Event("landing-session-expired"));
    }
    return Promise.reject(error);
  }
);

export default landingApi;
